import { Components, Theme } from '@mui/material/styles'

export const layoutCustomization: Components<Theme> = {
  MuiContainer: {
    styleOverrides: {
      root: {
        maxWidth: '1440px !important'
      }
    }
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        backgroundColor: 'transparent'
      },
      gutters: {
        boxShadow: 'none',
        backgroundImage: 'none'
      }
    }
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        backgroundColor: 'transparent'
      }
    }
  },
  MuiChip: {
    styleOverrides: {
      root: {
        padding: '12px 16px',
        borderRadius: '500px',
        border: '1px solid #4992FF',
        backgroundColor: '#4992FF4D !important'
      }
    }
  }
}
